import React, { useEffect } from 'react';

import { connect } from 'react-redux';

import { AppState } from '@redux/types';
import { ApplicationPrices } from '@redux/reducers/applications/types';
import {
  _getAppBySlug,
  _getPrices,
} from '@redux/reducers/applications/selectors';
import { _getCurrency } from '@redux/reducers/profile/selectors';

import Layout from '@components/organisms/Layout/Layout';
import LicensesTemplate from '@components/templates/LicensesTemplate';
import NotFoundTemplate from '@components/templates/NotFoundTemplate';

import { ROUTE } from '@utils/index';

import { Currency } from '@shared/interfaces/currency';
import {
  InitialProps,
  NextFCWithInitialProps,
  getInitialProps,
} from '@lib/getInitialProps';
import { Product } from '@shared/interfaces/product';
import Router, { Router as RouterType, withRouter } from 'next/router';
import { _getCards } from '@shared/markup/functions';

type LicensesProps = {
  isPromoNotFound: boolean;
  application: Product;
  currency: Currency;
  prices: ApplicationPrices[];
};

const Licenses: NextFCWithInitialProps<LicensesProps> = props => {
  const handleClick = subscriptionSlug => {
    if (subscriptionSlug) {
      const { application } = props;

      const url = ROUTE.APPLICATION.LICENSE(application.slug, subscriptionSlug);
      const schema = ROUTE.APPLICATION.LICENSE_SCHEMA;

      Router.push(schema, url);
    }
  };

  useEffect(() => {
    const { application } = props;

    if (!application) {
      Router.replace(ROUTE.PRICING);
    }
  }, [props]);

  const { isPromoNotFound, application, currency, prices } = props;

  if (isPromoNotFound) {
    return (
      <Layout>
        <NotFoundTemplate />
      </Layout>
    );
  }

  if (!application) {
    return null;
  }

  return (
    <Layout>
      <LicensesTemplate
        currency={currency}
        application={application}
        cards={_getCards(application.subscriptions)}
        onClickOption={handleClick}
        prices={prices}
      />
    </Layout>
  );
};

type LicensesInitialProps = InitialProps & {
  router: RouterType;
};

Licenses.getInitialProps = getInitialProps();

const withConnect = connect((state: AppState, props: LicensesInitialProps) => {
  const isPromoNotFound = props.isPromoNotFound;
  const { query } = props.router;
  const appSlug = query['app-slug'] as string;
  const application = _getAppBySlug(state, appSlug);

  return {
    isPromoNotFound,
    application,
    currency: _getCurrency(state),
    prices: _getPrices(state),
  };
});

export default Licenses;
